<div class="location-formatted-address">
  <div class="w-h-label html-overflow" *ngIf="withLabel" style="height: 19px">
    <mat-icon style="font-size: 18px; height: 18px" color="primary"
      >location_on</mat-icon
    >
    {{ formattedAddressLabel | translate }}
  </div>
  <div class="html-overflow default-value" *ngIf="locationDTO?.name">
    {{ locationDTO?.name }}
  </div>
  <div class="html-overflow default-value">
    {{ locationDTO?.formattedAddress ? locationDTO?.formattedAddress : "-" }}
  </div>
  <div class="html-overflow default-value" *ngIf="locationDTO?.locationSupplement">
    {{ locationDTO?.locationSupplement }}
  </div>
</div>
